var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotesX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.6665 6.7935H11.7398C10.1598 6.7935 8.87317 5.50683 8.87317 3.92683V2.00016C8.87317 1.6335 8.57317 1.3335 8.2065 1.3335H5.37984C3.3265 1.3335 1.6665 2.66683 1.6665 5.04683V10.9535C1.6665 13.3335 3.3265 14.6668 5.37984 14.6668H10.6198C12.6732 14.6668 14.3332 13.3335 14.3332 10.9535V7.46016C14.3332 7.0935 14.0332 6.7935 13.6665 6.7935Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5333 1.47317C10.26 1.19983 9.78662 1.3865 9.78662 1.7665V4.09317C9.78662 5.0665 10.6133 5.87317 11.62 5.87317C12.2533 5.87983 13.1333 5.87983 13.8866 5.87983C14.2666 5.87983 14.4666 5.43317 14.2 5.1665C13.24 4.19983 11.52 2.45983 10.5333 1.47317Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.1665H5C4.72667 9.1665 4.5 8.93984 4.5 8.6665C4.5 8.39317 4.72667 8.1665 5 8.1665H9C9.27333 8.1665 9.5 8.39317 9.5 8.6665C9.5 8.93984 9.27333 9.1665 9 9.1665Z",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 11.8335H5C4.72667 11.8335 4.5 11.6068 4.5 11.3335C4.5 11.0602 4.72667 10.8335 5 10.8335H7.66667C7.94 10.8335 8.16667 11.0602 8.16667 11.3335C8.16667 11.6068 7.94 11.8335 7.66667 11.8335Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesX);
export default __webpack_public_path__ + "static/media/notes_X.37e62679281b58f9047e88e6db298894.svg";
export { ForwardRef as ReactComponent };